module.exports = __webpack_public_path__ + "img/ic-airwallex.50847878.svg";